import Study from 'utils/study/study';

const hideLessons = (resource, hideCurrent = false) => {
  const resourceMap = {
    lessons: {
      elements: '.q-track-text, .q-track-video',
      currentElement: '.lesson-opened'
    },
    teachers: {
      elements: '.q-question-teacher',
      currentElement: '.teacher-opened'
    }
  };

  $(resourceMap[resource].elements)
    .not(hideCurrent ? null : resourceMap[resource].currentElement)
    .each((_, item) => {
      // Hide awareness banner
      $(item).prev().remove();
      // Show freemium block message
      $(item).next().show();
      // Remove item content
      $(item).remove();
    });
};

export function updateFreemiumCounter(resource) {
  Study.track(
    resource,
    response => {
      if (response[`${resource}_limit_reached`]) {
        hideLessons(resource);
      }
    },
    error => {
      if (
        error.response.status === 422 ||
        currentUser.subscriptionStatus === 'standard'
      ) {
        hideLessons(resource, true);
      }
    }
  );
}
